export const theme = {
  colors: {
    primary: '#2563eb',
    secondary: '#1e40af',
    accent: '#3b82f6',
    background: 'linear-gradient(135deg, #eff6ff 0%, #f1f5f9 100%)',
    card: '#ffffff',
    cardGradient: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
    text: '#1e293b',
    textLight: '#64748b',
    textSecondary: '#64748b',
    border: '#e2e8f0',
    error: '#ef4444',
    success: '#10b981',
    danger: '#ef4444',
    warning: '#f59e0b',
    blue: '#3b82f6',
    lightBlue: '#60a5fa',
    slate: '#64748b',
    primaryHover: '#1746a0',
    successHover: '#059669',
    dangerHover: '#dc2626',
  },
  borderRadius: {
    card: '24px',
    button: '12px',
    input: '8px',
  },
  boxShadow: {
    card: '0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    button:
      '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    input: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  },
  font: {
    title: '2.5rem',
    subtitle: '1.5rem',
    body: '1rem',
    small: '0.875rem',
  },
};
